import React from 'preact/compat';
import { useState } from 'preact/hooks';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';

import backgroundImage from '../../images/top_back.png';
import colors from '../colors';
import InfoIcon from '../icons/InfoIcon';
import HomeIcon from '@mui/icons-material/HomeRounded';
import { LauncherInfoPopup } from '../LauncherPopups';
import LauncherAdvancedSwitch from './LauncherAdvancedSwitch';

const LauncherHeader = ({appName, appVersion}) => {
    const [isInfoOpen, setInfoOpen] = useState(false);

    const toggleInfoOpen = () => {
        setInfoOpen(!isInfoOpen);
    }

    return (
        <>
        <Box
            sx={{
                width: '100%',
                background: `url(${backgroundImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top right'
            }}
        >
            <Stack
                direction="row"
                sx={{
                    maxWidth: 'calc(100% - 20px)',
                    width: 1108,
                    margin: 'auto',
                    gap: '20px',
                    height: '140px',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Box>
                    <Typography
                        variant="h1"
                        sx={{
                            fontSize: '40px',
                            fontWeight: 700,
                            color: colors.primaryText
                        }}
                    >
                        {appName} Launcher
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 300,
                            color: colors.ternaryText
                        }}
                    >
                        {appName} Version: {appVersion}
                    </Typography>
                </Box>
                <Stack
                    direction="row"
                    spacing="24px"
                    sx={{
                        '& .MuiIconButton-root, & .MuiLink-root': {
                            backgroundColor: colors.action,
                            borderRadius: '4px',
                            height: '32px',
                            width: '32px',
                            padding: 0,
                            alignItems: 'center',
                            display: 'flex',
                            color: colors.primaryText,
                            '&.Mui-disabled': {
                                backgroundColor: colors.actionDisabled
                            },
                            '&:hover': {
                                backgroundColor: colors.actionHover
                            }
                        }
                    }}
                >
                    <IconButton aria-label="go to the GDK website" href="/gdk/" target="_blank">
                        <HomeIcon sx={{color: colors.primaryText, fontSize: '24px'}} />
                    </IconButton>
                    <IconButton aria-label="help and info" component="label" onClick={toggleInfoOpen}>
                        <InfoIcon sx={{fill: colors.primaryText, fontSize: '32px'}} />
                    </IconButton>
                </Stack>
                <LauncherInfoPopup open={isInfoOpen} onClose={toggleInfoOpen} />
            </Stack>
        </Box>
        <Box
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                backgroundColor: colors.backgroundColor,
                padding: '20px 0 1px',
            }}
        >
            <Stack
                direction="row"
                sx={{
                    maxWidth: 'calc(100% - 20px)',
                    width: 1108,
                    margin: 'auto',
                    gap: '20px',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: '40px'
                }}
            >
                <LauncherAdvancedSwitch />
            </Stack>
            <Divider sx={{
                width: '100%',
                marginTop: '20px',
                borderColor: '#555555'
            }} />
        </Box>
        </>
    );

};

export default LauncherHeader;

